<script>
import axios from 'axios';
export default {
    methods: {
        validateStep2() {
            const data = this.SelectedData;
            const errors = [];
            if(!data.country) {
                errors.push('Country');
            }
            if(!data.phone) {
                errors.push('Phone');
            }

            if(errors.length) {
                this.errors = errors;
                return false;
            } else {
                this.errors = false;
            }
            return true;
        },
        sendTwilioRequest() {
            const phone = this.SelectedData.countryCode + this.SelectedData.phone;
            const formData = new FormData();
            formData.append('phone', phone);
            formData.append('country', this.SelectedData.countryShort);
            formData.append('transactionId', this.SelectedData.transactionId);
            formData.append('action', this.SelectedData.verification);
            return axios
                .post(this.siteUrl + 'include/API/sendTwilioRequest.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    console.log(response.data);
                    if(response.data == 'not valid phone') {
                        const errors = [];
                        errors.push('Cell/Phone is not valid. Please try again');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data == 'already requested this phone') {
                        const errors = [];
                        errors.push('Cell/Phone is already used before.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data == 'success') {
                        return true;
                    }
                    
                });
        },
    }
}
</script>